module.exports = __webpack_public_path__ + "img/2-01.53f17fd9.png";